import React, { useState, useLayoutEffect, useContext } from 'react';
import AddToCart from '../AddToCart/AddToCart';
import { ArticleFromDom } from '../../../../Integrations/ProductActionsIntegrations/Types';
import VoucherModal from './VoucherModal';
import { AccountContext } from '../../../Context/AccountContext';
import { ShopwareCartContext } from '../../../Context/ShopwareCartContext';
import { LocalCartContext } from '../../../Context/LocalCartContext';

import './VoucherActions.scss';

interface Props {
    article: VoucherFromDom;
    blocked?: boolean;
}

export interface VoucherDesign {
    name: string;
    previewImage: string;
    largeImage: string;
}

declare global {
    interface Window {
        __GGVoucherDesigns: VoucherDesign[];
    }
}

export interface VoucherFromDom extends ArticleFromDom {
    type: 'voucherWithDynamicPrice' | 'voucher';
    designName: string;
}

const VoucherActions: React.FunctionComponent<Props> = (props) => {
    const [voucherItem, updateVoucherItem] = useState<VoucherFromDom>({
        ...props.article,
    });

    const designs = [...window.__GGVoucherDesigns];
    const [modalVisible, updateModalVisible] = useState(false);
    const { isLoggedIn } = useContext(AccountContext);

    const cartContext = isLoggedIn ? ShopwareCartContext : LocalCartContext;
    const { activeItems } = useContext(cartContext);

    const voucherCartItem = activeItems.find((item) => item.articleNumber === voucherItem.articleNumber);

    const selectedDesignPreviewImage = designs.find((design) => design.name === voucherItem.designName)
        ?.previewImage as string;

    useLayoutEffect(() => {
        updateVoucherItem({ ...props.article });
    }, [props.article]);

    useLayoutEffect(() => {
        const domItem = document.querySelector(
            `.product-list__voucher[data-article-number="${voucherItem.articleNumber}"]`,
        );

        if (!domItem) {
            return;
        }
        const img = domItem.querySelector('.product-voucher__figure img');
        img?.setAttribute('src', selectedDesignPreviewImage);

        updateVoucherItem((currentVoucherItem) => ({
            ...currentVoucherItem,
            imageUri: selectedDesignPreviewImage,
        }));
    }, [selectedDesignPreviewImage]);

    useLayoutEffect(() => {
        if (voucherCartItem !== undefined) {
            updateVoucherItem((currentVoucherItem) => ({
                ...currentVoucherItem,
                designName: voucherCartItem?.voucher_design_name || '',
            }));
        }
    }, [voucherCartItem]);

    if (!designs || designs.length === 0) {
        return null;
    }

    return (
        <div className="voucher-actions">
            <VoucherModal
                updateModalVisible={updateModalVisible}
                modalVisible={modalVisible}
                updateVoucherItem={updateVoucherItem}
                designs={designs}
                voucherItem={voucherItem}
            />
            <button
                type="button"
                onClick={() => updateModalVisible(true)}
                disabled={voucherCartItem !== undefined}
                className="button voucher-actions__design-button"
            >
                Design wählen
            </button>
            <AddToCart article={voucherItem} blocked={props.blocked} />
        </div>
    );
};

export default VoucherActions;
